
export const active = (record) => {
  return String(record.status || record.Status).toLowerCase() === 'active'
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccms-gov-enrolments/filter.js